export default __webpack_public_path__ + "static/media/rt-tony-logo-stinkymonkey.25d36dad.png";